import { useState } from 'react';
import {
  DialogRoot,
  DialogPortal,
  DialogBackdrop,
  DialogPopup,
  DialogHeader,
  DialogTitle,
  DialogContent,
  DialogCloseButton,
} from '../ui/dialog';

export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);

  return (
    <footer className="border-t border-border bg-surface py-6">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          <p className="text-sm text-muted-foreground">
            &copy; 2026 Just Another Labs
          </p>

          <div className="flex items-center gap-4">
            <DialogRoot open={privacyOpen} onOpenChange={setPrivacyOpen}>
              <button
                onClick={() => setPrivacyOpen(true)}
                className="text-sm text-muted-foreground transition-colors hover:text-foreground"
              >
                Política de Privacidade
              </button>

              <DialogPortal>
                <DialogBackdrop />
                <DialogPopup className="max-h-[80vh] max-w-2xl overflow-y-auto">
                  <DialogHeader>
                    <DialogTitle>Política de Privacidade</DialogTitle>
                    <DialogCloseButton />
                  </DialogHeader>
                  <DialogContent>
                    <PrivacyPolicyContent />
                  </DialogContent>
                </DialogPopup>
              </DialogPortal>
            </DialogRoot>

            <span className="text-muted-foreground">|</span>

            <DialogRoot open={termsOpen} onOpenChange={setTermsOpen}>
              <button
                className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                onClick={() => setTermsOpen(true)}
              >
                Termos de Uso
              </button>

              <DialogPortal>
                <DialogBackdrop />
                <DialogPopup className="max-h-[80vh] max-w-2xl overflow-y-auto">
                  <DialogHeader>
                    <DialogTitle>Termos de Uso</DialogTitle>
                    <DialogCloseButton />
                  </DialogHeader>
                  <DialogContent>
                    <TermsOfUseContent />
                  </DialogContent>
                </DialogPopup>
              </DialogPortal>
            </DialogRoot>
          </div>
        </div>
      </div>
    </footer>
  );
}

function PrivacyPolicyContent() {
  return (
    <div className="prose prose-sm max-w-none text-foreground">
      <p className="text-muted-foreground">
        Última atualização: Janeiro de 2026
      </p>

      <h3 className="mt-4 text-lg font-semibold">1. Coleta de Informações</h3>
      <p className="text-foreground-subtle">
        Coletamos informações que você nos fornece diretamente, como dados de
        cadastro (nome e e-mail) e informações financeiras que você insere no
        aplicativo (rendas, despesas e orçamentos).
      </p>

      <h3 className="mt-4 text-lg font-semibold">2. Uso das Informações</h3>
      <p className="text-foreground-subtle">
        Utilizamos suas informações para:
      </p>
      <ul className="list-disc pl-5 text-foreground-subtle">
        <li>Fornecer e manter nossos serviços</li>
        <li>Personalizar sua experiência</li>
        <li>Sincronizar seus dados entre dispositivos</li>
        <li>Melhorar nossos serviços</li>
      </ul>

      <h3 className="mt-4 text-lg font-semibold">
        3. Armazenamento e Segurança
      </h3>
      <p className="text-foreground-subtle">
        Seus dados são armazenados de forma segura no Firebase (Google Cloud).
        Implementamos medidas de segurança técnicas e organizacionais para
        proteger suas informações contra acesso não autorizado.
      </p>

      <h3 className="mt-4 text-lg font-semibold">
        4. Compartilhamento de Dados
      </h3>
      <p className="text-foreground-subtle">
        Não vendemos, alugamos ou compartilhamos suas informações pessoais com
        terceiros, exceto quando necessário para fornecer nossos serviços ou
        quando exigido por lei.
      </p>

      <h3 className="mt-4 text-lg font-semibold">5. Seus Direitos</h3>
      <p className="text-foreground-subtle">
        Você tem o direito de acessar, corrigir ou excluir seus dados pessoais a
        qualquer momento. Para exercer esses direitos, entre em contato conosco.
      </p>

      <h3 className="mt-4 text-lg font-semibold">6. Cookies e Rastreamento</h3>
      <p className="text-foreground-subtle">
        Utilizamos cookies essenciais para o funcionamento do aplicativo e
        cookies de análise (Google Analytics) para entender como você usa nosso
        serviço.
      </p>

      <h3 className="mt-4 text-lg font-semibold">7. Contato</h3>
      <p className="text-foreground-subtle">
        Para dúvidas sobre esta política de privacidade, entre em contato pelo
        e-mail: justanotherlabs@gmail.com
      </p>
    </div>
  );
}

function TermsOfUseContent() {
  return (
    <div className="prose prose-sm max-w-none text-foreground">
      <p className="text-muted-foreground">
        Última atualização: Janeiro de 2026
      </p>

      <h3 className="mt-4 text-lg font-semibold">1. Aceitação dos Termos</h3>
      <p className="text-foreground-subtle">
        Ao acessar e usar o Controle Financeiro, você concorda com estes termos
        de uso. Se você não concordar com qualquer parte destes termos, não
        poderá usar nossos serviços.
      </p>

      <h3 className="mt-4 text-lg font-semibold">2. Descrição do Serviço</h3>
      <p className="text-foreground-subtle">
        O Controle Financeiro é uma plataforma de gerenciamento financeiro
        pessoal que permite aos usuários registrar rendas, despesas e criar
        orçamentos mensais.
      </p>

      <h3 className="mt-4 text-lg font-semibold">3. Conta do Usuário</h3>
      <p className="text-foreground-subtle">
        Para usar determinadas funcionalidades, você precisará criar uma conta.
        Você é responsável por manter a confidencialidade de suas credenciais e
        por todas as atividades realizadas em sua conta.
      </p>

      <h3 className="mt-4 text-lg font-semibold">4. Uso Aceitável</h3>
      <p className="text-foreground-subtle">Você concorda em:</p>
      <ul className="list-disc pl-5 text-foreground-subtle">
        <li>Usar o serviço apenas para fins legais</li>
        <li>Não tentar acessar contas de outros usuários</li>
        <li>Não interferir no funcionamento do serviço</li>
        <li>Fornecer informações precisas ao se cadastrar</li>
      </ul>

      <h3 className="mt-4 text-lg font-semibold">
        5. Limitação de Responsabilidade
      </h3>
      <p className="text-foreground-subtle">
        O serviço é fornecido &quot;como está&quot;. Não garantimos que o
        serviço será ininterrupto ou livre de erros. Não nos responsabilizamos
        por decisões financeiras tomadas com base nas informações do aplicativo.
      </p>

      <h3 className="mt-4 text-lg font-semibold">6. Propriedade Intelectual</h3>
      <p className="text-foreground-subtle">
        Todo o conteúdo, design e código do aplicativo são de propriedade
        exclusiva da Just Another Labs e estão protegidos por leis de direitos
        autorais.
      </p>

      <h3 className="mt-4 text-lg font-semibold">7. Modificações</h3>
      <p className="text-foreground-subtle">
        Reservamo-nos o direito de modificar estes termos a qualquer momento. As
        alterações entrarão em vigor imediatamente após a publicação.
        Recomendamos que você revise periodicamente estes termos.
      </p>

      <h3 className="mt-4 text-lg font-semibold">8. Encerramento</h3>
      <p className="text-foreground-subtle">
        Podemos encerrar ou suspender seu acesso ao serviço imediatamente, sem
        aviso prévio, por qualquer motivo, incluindo violação destes termos.
      </p>

      <h3 className="mt-4 text-lg font-semibold">9. Lei Aplicável</h3>
      <p className="text-foreground-subtle">
        Estes termos serão regidos e interpretados de acordo com as leis do
        Brasil, independentemente de conflitos de disposições legais.
      </p>

      <h3 className="mt-4 text-lg font-semibold">10. Contato</h3>
      <p className="text-foreground-subtle">
        Para dúvidas sobre estes termos de uso, entre em contato pelo e-mail:
        justanotherlabs@gmail.com
      </p>
    </div>
  );
}
